import { UiPricingComparisonTableModel } from "../../models";

import { mockUiPricingComparisonRowModel } from "./mock-ui-pricing-comparison-row";

export function mockUiPricingComparisonTableModel({
    id = "pricing-comparison-table-1234",
    type = "uiPricingComparisonTable",
    locale = "en",
    content = mockUiPricingComparisonTableModelContent()
}: Partial<UiPricingComparisonTableModel> = {}): UiPricingComparisonTableModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiPricingComparisonTableModelContent =
    UiPricingComparisonTableModel["content"];

export function mockUiPricingComparisonTableModelContent({
    entryTitle = "Demo pricing comparison table",
    title = "Demo pricing comparison table",
    featureColumnHeader = "Features",
    rows = [mockUiPricingComparisonRowModel()],
    ...optionals
}: Partial<UiPricingComparisonTableModelContent> = {}): UiPricingComparisonTableModelContent {
    return {
        entryTitle,
        title,
        featureColumnHeader,
        rows,
        ...optionals
    };
}
